export enum OpType {
  TEXT = "TEXT",
  PRODUCT = "PRODUCT",
}
export type TextOPValue = string;

export type ProductOpValue = {
  uuid?: string;
  title?: string;
  secondary_title?: string;
  item_number?: string;
  size?: string;
  price?: string;
  desc?: string;
  image_url?: string;
};

export interface Op {
  type: OpType;
  value: TextOPValue | ProductOpValue;
}

export type DisplayData = Op[];
